import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthenticationService } from '../../../_services/authentication/authentication.service';
import { SessionService } from '../../../_services/session/session.service';

@Component({
  standalone: true,
  selector: 'app-no-clinics',
  templateUrl: './no-clinics.component.html',
  styleUrls: ['./no-clinics.component.scss'],
  imports: [CommonModule, TranslatePipe],
})
export class NoClinicsComponent {
  constructor(
    private authService: AuthenticationService,
    private session: SessionService,
    private router: Router
  ) {}

  get isSuperUser(): boolean {
    return this.session.isSuperUser();
  }

  backToCustomers() {
    this.router.navigate(['/administration/customers']);
  }

  exitActing() {
    this.authService.exitActingCustomer().subscribe({
      next: () => this.router.navigate(['/administration/customers']),
    });
  }

  logout() {
    this.authService.logout();
  }
}
